import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SearchComponent } from './search.component';
import { DrawerModule } from '../drawer/drawer.module';
import { SectionHeaderModule } from '../section-header/section-header.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { AppCommonModule } from '../../app.common.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DrawerModule,
    AppCommonModule,
    SectionHeaderModule,
    LazyLoadImageModule
  ],
  declarations: [
    SearchComponent
  ],
  exports: [
    SearchComponent
  ]
})
export class SearchModule { }
